import {React, useEffect, useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { TextAreaField } from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { MaintainedInformationLease } from "../partials/FormFieldsLease";
import { MaintainedInformationAF } from "../partials/FormFieldsAF";
// import { Button } from "@mui/material";

// eslint-disable-next-line no-unused-vars
const MaintainedForm = ({ requestData, setRequestData, filter }) => {
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";
	const isLeasing = filter === "lease";
	const [formattedDate, setFormattedDate] = useState("");
	const [formData, setFormData] = useState(requestData);
	const [dbDateObject, setDbDateObject] = useState({
		__type: "Date",
		iso: formData?.maintenanceDueDate?.iso, 
	});

	useEffect(() => {
		const isoDate = dbDateObject?.iso;
		const formattedDate = isoDate?.substring(0, 16);
		setFormattedDate(formattedDate);
	}, [dbDateObject]);
	
	//state for editable date, due date in this case
	const handleDateChange = (e) => {
		const newIsoDate = new Date(e.target.value + ":00Z").toISOString();
		setFormattedDate(e.target.value);
		setDbDateObject({ __type: "Date", iso: newIsoDate });
		setFormData({...formData, maintenanceDueDate: { __type: "Date", iso: newIsoDate }})
	};

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// console.log(formData);
		setRequestData(formData);
	};

	// console.log(formData);

	//editable fields for  maintained assets
	const updatedData = {
		leaseData: {
			warranty: formData?.warranty,
			maintenanceFee: formData?.maintenanceFee,
			maintenanceDueDate: formData?.maintenanceDueDate,
			maintenanceStatus: formData?.maintenanceStatus,
			maintenanceComment: formData?.maintenanceComment,
		},
		AfData: {
			warranty: formData?.warranty,
			maintenanceFee: formData?.maintenanceFee,
			maintenanceDueDate: formData?.maintenanceDueDate,
			maintenanceStatus: formData?.maintenanceStatus,
			maintenanceComment: formData?.maintenanceComment,
		},
	};

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					updatedData={updatedData}
				/>

				<div className='RightSection'>
					<FormAccordion title='Maintenance Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							{isLeasing ? (
								<MaintainedInformationLease
									formData={formData}
									setFormData={setFormData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									handleDateChange={handleDateChange}
									formattedDate={formattedDate}
								/>
							) : (
								<MaintainedInformationAF
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									handleDateChange={handleDateChange}
									formattedDate={formattedDate}
									
								/>
							)}
						</div>
					</FormAccordion>

					<FormAccordion title='Comment' open={true}>
						<div className='form-group'>
							<TextAreaField
								name='maintenanceComment'
								isEditable={isEditable}
								value={
									formData?.maintenanceComment || formData?.productId?.comment
								}
								handleChange={handleInputChange}
							/>
						</div>
					</FormAccordion>

					{/* <div className='flex'>
						<Button variant='contained' type='submit'>
							Save
						</Button>

						<Button variant='outlined' onClick={handleCancel}>
							Cancel
						</Button>
					</div> */}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
MaintainedForm.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
};

export default MaintainedForm;
